module.exports = __webpack_public_path__ + "static/media/fsc6.7b4d7c2b.svg";